import { Box, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import UseTranslation from '../../../../hooks/UseTranslation'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import FinishModalContainer from '../../../../components/Modals/FinishModalContainerV2'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import SeeMoreText from '../../../../components/Cards/helpers/SeeMoreText'
import { ReactComponent as Manager } from '../../../../images/Manager.svg'
import OfoqTextArea from '../../../../components/Forms/OfoqTextArea'
import { NotificationsInboxActionsBulk } from '../../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import GenericBtn from '../../../../components/Buttons/OfoqThemeBtn'
import { decodeHtmlString } from '../../../../utils/helpers'
import successImage from '../../../../images/success.svg'
import {
  approveNotificationsSelectedRequestFinish,
  rejectNotificationsSelectedRequestFinish,
} from '../../../../utils/finishDataContiner'
import appRoutes from '../../../../services/AppRoutes'
import { getNotificationConfirmationData } from '../../../../utils/confirmationDataContainer'
import ConfirmationModalContainerV2 from '../../../../components/Modals/ConfirmationModalContainerV2'

const SelectionModel = ({
  modalStatus, setModalStatus, selectedData, actionAfterSuccess, setSelectedCards,
}) => {
  const { t } = UseTranslation()
  const isApprove = modalStatus.type === 'approve'
  const dispatch = useDispatch()
  const [requestFinish, setRequestFinish] = useState(false)
  const [confirmationClicked, setConfirmationClicked] = useState(false)
  const history = useHistory()
  const [modalData, setModalData] = useState(null)

  const handleNotificationRequestForm = () => {
    const selectedIdsAndComments = selectedData?.map((notification) => ({
      id: notification?.id,
      comment: notification?.comment || null,
    }))

    dispatch(
      NotificationsInboxActionsBulk({
        action: isApprove ? 'approve' : 'reject',
        queries: { requests: selectedIdsAndComments },
      }),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setRequestFinish(true)
        setSelectedCards([])
        cancelHandler()
      }
    })
  }
  const cancelHandler = () => {
    setModalStatus({
      status: false,
      type: modalStatus.type,
    })
  }
  const handleClick = () => {
    setConfirmationClicked(true)
    cancelHandler()

    const action = isApprove ? 'approve' : 'reject'
    const count = selectedData?.length || 0
    const modalAction = getNotificationConfirmationData(action, count, t)
    setModalData(modalAction)
  }
  const finishModalHandler = () => {
    setRequestFinish(false)
    if (actionAfterSuccess) {
      actionAfterSuccess()
    }
  }
  const handleCommentChange = (id, value) => {
    setSelectedCards(
      (prevSelectedCards) => prevSelectedCards.map(
        (item) => (item.id === id ? { ...item, comment: value } : item),
      ),
    )
  }
  return (
    <Box data-testid="selection-modal">
      <FormModalContainer
        modalTitle={isApprove ? t?.['Approve Selected Requests'] : t?.['Reject Selected Requests']}
        modalState={modalStatus.status}
        handleClose={cancelHandler}
        cancelText={t?.Close}
        largeSize
      >
        <Typography sx={styles.comments}>{t?.['Please add your comments if needed on your selected requests.']}</Typography>
        {selectedData?.map((notification) => (
          <Box
            key={notification?.id}
            sx={styles.card}
          >
            <TitleWithIcon
              title={(
                <Box sx={styles.cardTitle}>
                  <Typography variant="body1" sx={styles.cardTitleName}>
                    {`${notification?.employee?.name}`}
                  </Typography>
                </Box>
                  )}
              icon={<Manager />}
              customStyle={styles.stackFlex}
            />
            <SeeMoreText
              text={decodeHtmlString(notification?.description)}
              customStyle={styles.mobileNotesInfo}
            />

            <OfoqTextArea
              name={t?.['Add Comment']}
              customPlaceHolder={t?.['Type your comment Here']}
              refState={(value) => handleCommentChange(notification?.id, value)}
              defaultValue={notification?.comment || ''}
              customStyle={styles.textArea}
            />
          </Box>
        ))}
        <Box sx={styles.btnsContainer}>
          <GenericBtn customStyle={styles.cancelBtn} name={`${t?.cancel}`} onClick={cancelHandler} cancelStyle />
          <GenericBtn
            name={isApprove ? t?.Approve : t?.Reject}
            onClick={handleClick}
            customStyle={styles.sendBtn}
          />
        </Box>
      </FormModalContainer>
      <ConfirmationModalContainerV2
        modalState={confirmationClicked}
        setModalState={setConfirmationClicked}
        modalData={modalData}
        functionToDispatch={handleNotificationRequestForm}
        customHandleClose={() => {
          setConfirmationClicked(false)
          setModalStatus({
            status: true,
            type: modalStatus.type,
          })
        }}
      />
      <FinishModalContainer
        modalState={requestFinish}
        actionAfterSuccess={finishModalHandler}
        modalData={isApprove
          ? approveNotificationsSelectedRequestFinish : rejectNotificationsSelectedRequestFinish}
        modalIcon={successImage}
      >
        <Box sx={styles.modalMsg}>
          <Typography sx={styles.modalMsgText} variant="heading4">
            {t?.['You can monitor the status of these actions in the']}
            <Typography component="span" sx={styles.modalMsgSpan} onClick={() => history.push(appRoutes.ActionHistory)}>
              {t?.['Action History Screen']}
            </Typography>
          </Typography>
        </Box>
      </FinishModalContainer>
    </Box>
  )
}

const styles = {
  stackFlex: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      display: { xs: 'none', md: 'flex' },
      height: '20px',
      width: '20px',
      filter: 'brightness(0) saturate(100%) invert(60%) sepia(98%) saturate(331%) hue-rotate(90deg) brightness(91%) contrast(91%)',
    },
    '& span': {
      marginLeft: { xs: '-7px', md: '10px' },
    },
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  cardTitleName: {
    fontSize: { xs: '14px', sm: '18px' },
  },
  comments: {
    padding: '20px 10px',
    fontSize: { xs: '14px', sm: '16px' },
  },
  card: {
    borderTop: (theme) => `1px solid ${theme.palette.grey[200]}`,
    padding: '20px 10px',
  },
  btnsContainer: {
    display: 'flex',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
    padding: { xs: '0 16px', sm: '10px 16px 0 16px' },
    margin: { xs: '0px  -16px 0px -16px', sm: '0 -16px' },
    borderTop: (theme) => ({
      xs: 'none',
      sm: `1px solid ${theme.palette.grey[200]}`,
    }),
  },
  sendBtn: {
    marginLeft: { xs: 'unset', sm: '10px' },
    maxWidth: { xs: '100%', sm: '96px' },
  },
  cancelBtn: {
    display: { xs: 'none', sm: 'block' },
    marginLeft: { xs: 'unset', sm: '10px' },
    width: { xs: '100%', sm: '96px' },
    minWidth: { xs: '80px', sm: '96px' },
    textAlign: 'center',
  },
  mobileNotesInfo: {
    alignItems: 'center',
    paddingLeft: { xs: '0px', md: '25px' },
    margin: { xs: '5px 0px', md: '10px 0px 0px' },
    color: 'grey.500',
    '& span': {
      overflowWrap: 'break-word',
    },
    '& p': {
      margin: { xs: '0px', md: '5px' },
      fontSize: { xs: '12px', sm: '14px' },
    },
  },
  modalMsg: {
    display: 'flex', textAlign: 'center', justifyContent: 'center', mt: '-20px',
  },
  modalMsgSpan: { color: 'primary.main', cursor: 'pointer' },
  modalMsgText: { color: 'grey.500', paddingRight: '5px' },
  textArea: {
    resize: 'none',
    margin: '17px 0px 0px !important',
    '& label': {
      margin: '0px !important',
    },
  },
}
export default SelectionModel
